module.exports = __webpack_public_path__ + "static/media/mates-and-relates-icon-200px@3x.6e824081.png";